module.exports = __webpack_public_path__ + "static/img/4.1293b74.png";


//////////////////
// WEBPACK FOOTER
// ./static/ALL/4.png
// module id = uzUI
// module chunks = 202